import { ImageWraper } from '@components/shared/wraper/ImageWraper'
import { cloudfrontPath } from '@utils/image'

type Props = {
  referer: string
}

export const TrialSessionLink = ({ referer }: Props): JSX.Element => (
  <a
    href="https://hr.buzzkuri.com/trial-top"
    data-referer={referer}
    target="_blank"
    rel="noreferrer"
  >
    <div className="lg:hover:opacity-80 lg:hover:cursor-pointer">
      <ImageWraper
        src={`${cloudfrontPath}/programs/icons/top/trial@2x.png`}
        width={630}
        height={444}
      />
    </div>
  </a>
)
